export default {
  data() {
    return {
      search: '',
      limit: 25,
    };
  },

  methods: {
    onChange(name, value) {
      this[name] = value;
      this.all(1, this.limit);
    },

    getSearch(limit = 25) {
      this.limit = limit;
      return this.search;
    },
  },

  components: {
    VText: require('./../components/form/text/text.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/search.js